export const INITIAL_USER = {
	displayName: '',
	userName: '',
	email: '',
	password: '',
	role: '',
	companyId: '',
	isPermitAll: true,
	userPermissions: [],
};
